import React from "react";
import PropTypes from "prop-types";
import * as Table from "reactabular-table";

import { genUnitValueFormatter } from "../tabellen/Tabellen";
import { injectIntl, intlShape } from "react-intl";

import "./Zubehoer.css";

const genAinFuncFormatter = (units, intl) => {
	const presFormatter = genUnitValueFormatter("pressure", units, intl, true);
	const tempFormatter = genUnitValueFormatter("temperature", units, intl, true);
	const flowFormatter = genUnitValueFormatter("volume_over_minutes", units, intl, true);

	return (value, row) => {
		let result = "---";
		if (Number.isFinite(value)) {
			switch(row.rowData.function) {
			case "pressure":
				result = presFormatter(value);
				break;
			case "volume_flow":
				result = flowFormatter(value);
				break;
			default:
				result = tempFormatter(value);
				break;
			}
		}
		return result;
	};
};

const genNameAnalogInputs = (intl) => {
	return (value, row) => {
		let name = "----------";
		if (value) {
			switch(row.rowData.index) {
				case "ADD_PRESS_1":
					name = intl.formatMessage({ id: "Decenteralized Pressure 1"});
					break;
				case "ADD_PRESS_2":
					name = intl.formatMessage({ id: "Decenteralized Pressure 2"});
					break;
				case "ADD_PRESS_3":
					name = intl.formatMessage({ id: "Decenteralized Pressure 3"});
					break;
				case "ADD_PRESS_4":
					name = intl.formatMessage({ id: "Decenteralized Pressure 4"});
					break;
				default:
					name = row.rowData.name;
					break;
			}
		}
		return name;
	};
};

const ZubehoerPayload = props => (
	<Table.Provider
		className="Zubehoer"
		columns={[{
			property: "name",
			cell: {
				formatters: [
					genNameAnalogInputs(props.intl)
				]
			},
			header: {
				label: props.intl.formatMessage({ id: "Label" })
			}
		}, {
			property: "value",
			cell: {
				formatters: [
					genAinFuncFormatter(props.units, props.intl)
				]
			},
			header: {
				label: props.intl.formatMessage({ id: "Current value" })
			}
		}]}>
		<Table.Header />
		<Table.Body rows={props.analog_inputs} rowKey="index" />
	</Table.Provider>
);

ZubehoerPayload.propTypes = {
	analog_inputs: PropTypes.array.isRequired,
	units: PropTypes.object.isRequired,
	intl: intlShape.isRequired
};

export default injectIntl(ZubehoerPayload);
